import React, { useState, useContext } from "react";
import { alertSuccess } from "@/utils/alerts";
import { t } from "i18next";
import useFormState from "../../../utils/useFormState";
import { AuthContext } from "@/App.jsx";
import Button from "Components/button/Button";
import Input from "Components/input/Input";
import isFQDN from "validator/lib/isFQDN";
import Modal from "Components/smallModal/smallModal";
import TranslatedString from "Components/TranslatedString";
import QboxmailApi from "@/qboxmailApi";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import WarningBanner from "Components/warningBanner/WarningBanner";
import { useHistory } from "react-router-dom";

const api = new QboxmailApi({ useCookie: true });

export default function DomainNewScreen() {
  const {
    setFormFieldValue,
    setFormLoading,
    isFormLoading,
    unsetFormLoading,
    formData,
    formErrors,
    setFormErrors,
    handleFormResponseErrors,
  } = useFormState({
    name: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();
  const auth = useContext(AuthContext);
  const [responseData, setResponseData] = useState(null);

  const validate = () => {
    if (!isFQDN(formData.name)) {
      setFormErrors({ name: t("errorMsg.notValid.domain") });
      return false;
    }

    return true;
  };

  const submit = async () => {
    const isValid = validate();

    if (!isValid) {
      return;
    }

    let err = null;

    setFormLoading();

    try {
      const resp = await api.createDeliveryDomain(formData);
      setResponseData(resp.resources[0]);
    } catch (e) {
      err = await handleFormResponseErrors(e);
    }

    unsetFormLoading();

    if (!err) {
      alertSuccess(t("alert.domainCreatedSuccess"));
      setIsModalOpen(true);
    }
  };

  const setCustomerCode = (data) => {
    setFormFieldValue({
      customer_code: data ? data.value : "",
    });
  };

  const goToVerification = () => {
    auth.isLoggedUserAdmin()
      ? history.push(`/customers/${responseData.customer_code}/delivery/domains/${responseData.code}/verification`)
      : history.push(`/delivery/domains/${responseData.code}/verification`);
  };

  return (
    <>
      <div className="screenContainer flexAlignCenter">
        <div className="mt-4 w-full max-w-[--form-page-width]">
          <div className={"sectionTitle"}>{t("delivery.domains.add.step1.title")}</div>
          <div className="sectionDesc">{t("delivery.domains.add.step1.desc")}</div>
          <Button docsKey="deliveryAddDomain" className="btnDocsFP" color="docs" sizeSmall>
            button.docs
          </Button>
        </div>
        <div className="formContainer">
          <div className="flexColumnContainer">
            <div className="formSection">
              {auth.isLoggedUserAdmin() && (
                <CustomerSelect
                  withoutDomainCounter
                  className="inputFull2"
                  label={t("input.label.customer")}
                  onChange={setCustomerCode}
                  errors={formErrors.customer_code}
                />
              )}

              <div className="formSection">
                <Input
                  className="inputFull2"
                  name="name"
                  trim
                  label={t("delivery.domains.add.step1.name.msg")}
                  wrapperClassName="mt-3"
                  placeholder={t("input.placeholder.domain.name")}
                  type="text"
                  value={formData.name}
                  errors={formErrors.name}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                  autoCapitalize="off"
                  required
                />
              </div>
            </div>
          </div>

          <div className="flexColumnContainer">
            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner color="red" msg={formErrors.onForm} fullWidth />
              </div>
            )}

            <div className="mt-5 py-4 border-t border-[--bg-d5] w-full flex justify-stretch sm:justify-end items-end gap-2 form-footer-mobile-buttons">
              <Button onClick={() => history.push("/delivery/domains")} color="text" type="button">
                button.cancel
              </Button>
              <Button color="green" onClick={submit} loading={isFormLoading}>
                button.create
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Modal modalClassName="pb-4" title={t("alert.domainCreatedSuccess")} opened={isModalOpen}>
        <div className="section">
          <TranslatedString>delivery.domains.add.modal.message</TranslatedString>
        </div>
        <div className="section">
          <Button type="button" color="accent" onClick={goToVerification}>
            button.goToVerification
          </Button>
        </div>
      </Modal>
    </>
  );
}
